<template>
  <div :class="['nsr-item-module-group', { ignored: group.ignored }]">
    <!-- Header -->
    <div class="nsr-item-module-group-header">
      <h3 class="nsr-item-module-group-name">
        Group {{ String.fromCharCode(65 + idx) }}
      </h3>
      <v-text-field
        outlined
        dense
        hide-details
        label="Name"
        :value="group.name"
        @input="onUpdate({ name: $event })"
      ></v-text-field>
      <v-spacer></v-spacer>
      <v-btn text color="primary" @click="$emit('delete')">Delete Group </v-btn>
      <v-checkbox
        dense
        hide-details
        class="ignore-checkbox ml-4"
        :input-value="group.ignored"
        @change="onUpdate({ ignored: $event })"
      >
        <template #label>
          <span
            style="
              font-family: Roboto, sans-serif;
              font-size: 14px;
              font-weight: 500;
              font-stretch: 100%;
              letter-spacing: 1.25px;
              line-height: normal;
              text-indent: 1.25px;
            "
            >IGNORE GROUP</span
          >
        </template>
      </v-checkbox>
      <v-btn
        icon
        :disabled="!group.ignored && !collapsed"
        class="ml-2"
        color="primary"
        @click="collapsed = !collapsed"
      >
        <v-icon v-if="collapsed">mdi-plus-box-outline</v-icon>
        <v-icon v-else>mdi-minus-box-outline</v-icon>
      </v-btn>
    </div>

    <!-- MODULE -->
    <NsrItemModule
      v-for="(module, moduleIdx) in collapsed ? [] : modules"
      :key="moduleIdx"
      :module="module"
      :idx="moduleIdx"
      @update="onModuleUpdate(moduleIdx, $event)"
      @delete="removeModule(moduleIdx)"
    ></NsrItemModule>

    <!-- FOOTER -->
    <v-card-actions v-if="!collapsed">
      <div style="width: 200px">
        <v-btn color="primary" outlined @click="addModule">Add Module </v-btn>
      </div>
      <div style="width: 296px; text-align: right">
        Total{{
          group.name
            ? ` (${group.name})`
            : ` (Group ${String.fromCharCode(65 + idx)})`
        }}:
      </div>
      <div style="padding-left: 46px; font-weight: bold">
        {{ $parseCurrency(group.sub_total) }}
      </div>
    </v-card-actions>
  </div>
</template>
<script>
import NsrItemModule from "@/components/nsr/NsrItemModule";
import { ref, watch, inject } from "@vue/composition-api";
import { RBU_MODULE_TENDER_RATE_MODE } from "@/constants";
import floatingPointFix from "js-floating-point";

export default {
  name: "NsrRbuItemModuleGroup",
  components: { NsrItemModule },
  props: {
    group: Object,
    idx: Number,
  },
  setup(props, { root, emit }) {
    const item = inject("NSR_RBU_ITEM");
    const nsr_item = inject("NSR_ITEM");
    const collapsed = ref(false);
    const group = ref(null);
    const modules = ref([]);

    const groupTotal = function (g) {
      let grp = g || props.group;

      let total = 0;
      grp.modules.forEach((m) => {
        if (!m.ignored && m.sub_total)
          total = floatingPointFix(total + parseFloat(m.sub_total));
      });
      return total;
    };

    const onUpdate = function (evt) {
      console.debug("Item Module Group Update: ", evt);

      let updates = {
        ...props.group,
        ...evt,
      };
      updates.sub_total = groupTotal(updates);

      let calculated_sub_total = updates.sub_total;

      if (props.group.group_formula) {
        try {
          if (props.group.group_formula.includes("{{value}}")) {
            const formula = props.group.group_formula.replaceAll(
              "{{value}}",
              calculated_sub_total
            );
            calculated_sub_total = floatingPointFix(eval(formula));
          } else {
            const formula = calculated_sub_total + props.group.group_formula;
            calculated_sub_total = floatingPointFix(eval(formula));
          }
        } catch (e) {
          console.log(e);
          calculated_sub_total = updates.sub_total;
        }
      }

      updates.calculated_sub_total =
        Math.round(floatingPointFix(calculated_sub_total * 100)) / 100;

      emit("update", updates);
    };

    const addModule = function () {
      let unit = nsr_item.unit;

      modules.value.push({
        order_no: modules.value.length,
        ignored: false,
        portion: 100,
        adjustment_value_first: true,
        adjustment_percentage: 100,
        adjustment_percentage_formula: "",
        adjustment_value: 0,
        adjustment_value_formula: "",
        tender_rate_mode: RBU_MODULE_TENDER_RATE_MODE.SUM,
        datapoint_mode: RBU_MODULE_TENDER_RATE_MODE.SUM,
        tender_rate_unit: unit,
        datapoint_unit: unit,
      });
    };
    const onModuleUpdate = function (moduleIdx, m) {
      console.debug(`onModuleUpdate: ${moduleIdx}`, m);
      modules.value.splice(moduleIdx, 1, m);

      onUpdate({ modules: modules.value });
    };
    const removeModule = function (moduleIdx) {
      modules.value.splice(moduleIdx, 1);
    };

    watch(
      () => props.group,
      (newValue) => {
        if (newValue) {
          group.value = newValue;
          modules.value = newValue.modules;

          if (modules.value.length === 0) {
            addModule();
          }
        }
      },
      { immediate: true }
    );

    return {
      collapsed,
      modules,
      onUpdate,
      addModule,
      onModuleUpdate,
      removeModule,
    };
  },
};
</script>

<style lang="less">
.nsr-item-module-group {
  background-color: rgba(255, 255, 255, 0.5);
  border-radius: 8px;
  margin-top: 2rem;
  padding: 16px 0;
  display: flex;
  flex-direction: column;

  &.ignored {
    background-color: rgba(0, 0, 0, 0.2);
  }

  .nsr-item-module-group-header {
    display: flex;

    .nsr-item-module-group-name {
      padding: 0 16px;
      margin-right: 16px;
      display: flex;
      align-items: center;
      color: var(--v-primary-base);
    }

    .ignore-checkbox {
      i,
      label {
        color: var(--v-primary-base);
      }
    }
  }
}
</style>
